import React, { useContext, useEffect, useState } from 'react'
import axios from 'axios';
import { useLocation, useSearchParams } from 'react-router-dom';
import { UserContext } from '../../App';
import { Link } from 'react-router-dom';
import { LoadingFull } from '../loading';

export const LoadBooks = ({ data }) => {

  const { user } = useContext(UserContext)
  const { search } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const bookId = searchParams.get('id');
  return (
    <div className="relative grid grid-cols-2 gap-x-6 gap-y-10 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-7 xl:gap-x-8">
      {data.length > 0 ?
        data.filter(book => (typeof user !== 'undefined' ? book.dbBook.ejer !== user._id : typeof book !== 'undefined')).map((book) => (
          <Link to={`/bøger/${book.dbBook._id}`}>
            <div className="book cursor-pointer h-full flex flex-col gap-2 justify-between">
              <div className="flex flex-col gap-2">
                <div className="aspect-h-1 aspect-w-1 w-full h-56 bg-neutral-100 xl:aspect-h-8 xl:aspect-w-7 p-2">
                  <img src={`https://firebasestorage.googleapis.com/v0/b/bolig2.appspot.com/o/${book.dbBook['_id']}%2F0?alt=media`} className="h-full w-auto object-contain m-auto" alt="Slide 1" />
                </div>
                <div className="flex flex-col">
                  <h5 className="text-sm md:text-sm xl:text-base text-gray-700 font-medium">{book.apiBook.title}</h5>
                  <p className="text-sm text-gray-700 font-normal">{book.apiBook.director.map((dir, index) => {
                    if (index !== 0) {
                        return `, ${dir['$']}`
                    } else {
                        return ` ${dir['$']}`
                    }
                  })}</p>
                </div>
              </div>
              <p className="text-base font-medium select-none">{Number(book.dbBook.price/100).toFixed(2).toString().replace(/\./g, ',')} kr.</p>
            </div>
          </Link>
        ))
      :
        ""}
    </div>
  )
}